import { Box } from '@mui/material';
import React, { ReactNode } from 'react'

interface LandingPageTemplateProps {
    navbar: ReactNode;
    carousel: ReactNode;
    claim: ReactNode;
    cards: ReactNode;
    bpmnPreview: ReactNode;
    stats: ReactNode;
    cta: ReactNode;
    footer: ReactNode;
}

export default function LandingPageTemplate({
    navbar,
    carousel,
    claim,
    cards,
    bpmnPreview,
    stats,
    cta,
    footer
}: LandingPageTemplateProps) {
    return (
        <Box>
            {navbar}
            {carousel}
            {claim}
            {cards}
            {bpmnPreview}
            {stats}
            {cta}
            {footer}
        </Box>)
}

